export default __webpack_public_path__ + "static/egypt-for-first-time-adventurers-luxor-d72a28e9076ece02a726ca3fa52e63e7.jpg";